import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, allowedRoles }) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const employeeId = sessionStorage.getItem("employeeId");
    
    // Not logged in at all
    if (!employeeId) { 
      setStatus('denied'); 
      return; 
    }

    // Verify role against DB
    fetch('/api/verifyRole', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ employeeId, allowedRoles })
    })
    .then(res => res.json())
    .then(data => setStatus(data.allowed ? 'allowed' : 'denied'))
    .catch(() => setStatus('denied'));
  }, []);

  if (status === 'loading') return <div>Loading...</div>;
  
  if (status === 'denied') {
    const role = sessionStorage.getItem("role");
    // Redirect to their correct home based on role
    return role === 'HRAdmin' 
      ? <Navigate to="/dashboard" replace /> 
      : <Navigate to="/" replace />; // not logged in or employee → login
  }

  return children;
}

export default ProtectedRoute;